import { createSelector, Selector } from "@reduxjs/toolkit";

import { Activity, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { UaaSelectors } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { getLatestFVManifestByKey } from "../../app/slices/fachverfahren/selectors";

import { isAdmin, isUser, selectStructuredRoles } from "../user";

export const ModulfDataSelectors = {
	selectTaskDocument: (activityId: string): Selector<any, Activity.Data.Document | undefined, never> => {
		return state => {
			const activity = ActivitySelectors.activityById(activityId)(state);
			const dataholder = Activity.findDefaultDataHolder(activity);
			const data = dataholder?.data as FormActivity.Data.SingleDocumentData | undefined;
			return data?.document;
		};
	}
};

export function selectAvailableClients(fachverfahrenKey: string): Selector<any, string[], never> {
	return createSelector(
		[(state: any) => getLatestFVManifestByKey(fachverfahrenKey)(state), UaaSelectors.user],
		(manifest, rawUser) => {
			const user = isUser(rawUser) ? rawUser : undefined;
			if (!user) {
				return [];
			}

			const userClients = selectStructuredRoles(user)
				.filter(
					it =>
						it.key === manifest?.identification.key &&
						it.roles.length > 0 &&
						(it.roles.length > 1 || it.roles[0] !== "betrachter")
				)
				.map(it => it.client ?? "");

			return (
				manifest?.clients
					?.map(it => (it.key === "\u200b" ? "" : (it.key ?? "")))
					.filter(it => isAdmin(user) || userClients.includes(it)) ?? Array.from(userClients.values())
			);
		}
	);
}
